import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';
import { Blogverify } from './blogverify.page';
export const routes: Routes = [
    { path: 'blogverify', component: Blogverify }
];
@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        RouterModule.forChild(routes)
    ],
    declarations: [
        Blogverify
    ]
})
export class BlogverifyModule { }



// WEBPACK FOOTER //
// F:/SVNNew/Web/Phoenix HealthCare/HealthCare_UI/src/app/structure/blogverify/blogverify.module.ts